<template>
	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">KAKAO 로그인 진행중</h2>
				<p class="sub-tit">KAKAO 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "kakaoIOSReturn",
	data() {
		return {
			LOCAL: location.hostname,
		}
	},
	created() {
		var self = this;

		this.axiosCaller.post(this, 'https://kauth.kakao.com/oauth/token?'
				+ 'grant_type=' + 'authorization_code' + '&'
				+ 'client_id=' + this.APIs.KAKAO_REST_API_LOGIN_KEY + '&'
				+ 'redirect_uri=' + this.APIs.KAKAO_IOS_LOGIN_RETURN + '&'
				+ 'code=' + new URL(window.location.href).searchParams.get("code"),
				{}, (res) => {

					if (res.statusText === 'OK') {

						this.axiosCaller.get(this, this.APIs.OAUTH + '/kakao', {
							code: this.code,
							accessToken: res.data.access_token,
							contentType: 'application/x-www-form-urlencoded;charset=utf-8',
							redirectUri: this.APIs.KAKAO_IOS_LOGIN_RETURN
						}, (res) => {

							if (res.data.result.statusCode === "OK") {

								this.axiosCaller.get(this, this.APIs.SESSION + "/doSnsLogin", {
									snsService: "kakao",
									snsId: JSON.parse(res.data.result.body)['id'],
									deviceToken: (this.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
								}, async (res) => {

									const result = res.data;

									if (result.status === "ok") {
										if (await this.setSessionProc(result.coAccountVO)) {
											self.setSessionKeep(this.isKeepSession);
											self.goWithCoCode(self)
										}
									} else {
										this.swalUtils.gritter("Error", result.msg, "question", 1500, () => {
											history.back()
										})
									}
								})


							}
						})
					}
		})
	},
	mounted() {
		this.appDeviceToken("#deviceToken")
	},
	methods: {
		goReferrer() {
			if (!this.stringUtils.isEmpty(this.$route.query.referrer)) {
				console.log(this.$route.query.referrer)
				location.href = this.$route.query.referrer
			} else {
				location.href = "/"
			}
		},
	}
}
</script>

<style scoped>

</style>
